import {
    AppBar,
    Box,
    Button,
    Card,
    CardHeader,
    Container,
    createStyles,
    Drawer,
    Grid,
    IconButton,
    List,
    ListItem,
    makeStyles,
    Paper,
    Theme,
    Toolbar,
    Typography,
} from '@material-ui/core';
import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useImperativeHandle,
    forwardRef,
    ForwardRefRenderFunction,
    Dispatch,
    SetStateAction,
    Fragment,
} from 'react';
import {
    oper as v_oper,
    basic,
    Values,
    product as v_product,
    order as v_order,
    SNACKBAR_TIME,
    FINISH_TIME,
} from '../../request/values';
import { Waypoint } from 'react-waypoint';

import NumberFormat from 'react-number-format';

import clsx from 'clsx';

import { COLORS } from '../Theme';

// Icon

import Dialog, { DialogConfirm, DialogInputText } from '../Dialog';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { SIcon } from '../Icon';
import { useHistory } from 'react-router-dom';
import ToastStr from '../../request/toastStr';
import TitleBar from '../header/TitleBar';
import { TurnedIn } from '@material-ui/icons';
import { Toast } from 'react-bootstrap';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: 0,
            height: '88vh',
            paddingTop: '3.5vh',
            background: `${COLORS.WHITE}`,
        },
        productItem: {
            borderRadius: 5,
            border: 'solid 1px #d3d3d3',
            margin: 'auto',
            marginBottom: '1.5vh',

            width: '80%',
            padding: 0,

            '& #itemWrap': {
                width: '100%',
                display: 'flex',
                padding: '0',
                justifyContent: 'center',
                // alignItem: 'center',
            },
        },

        list: {
            height: '74vh',
            width: '100%',
            overflowY: 'auto',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            [theme.breakpoints.up('md')]: {
                height: '85vh',
            },
        },
        productImage: {
            textAlign: 'center',
            margin: 'auto',
            '& img': {
                // width: '18vw',
                height: '6.5vh',
            },
        },
        productPrice: {
            fontSize: '2.5vw',
            //fontWeight: 'bold',
            fontFamily: 'NanumB',
            color: `${COLORS.PUMPKIN}`,
            [theme.breakpoints.up('md')]: {
                fontSize: '14px',
            },
        },
        productCompanyName: {
            fontSize: '3vw',
            fontWeight: 'bold',
            fontFamily: 'NanumB',
            color: `${COLORS.WATER_BLUE}`,
            [theme.breakpoints.up('md')]: {
                fontSize: '18px',
            },
        },
        buttonLabel1: {
            color: `${COLORS.BROWNISH_GREY}`,
            fontSize: 18,
            fontFamily: 'NanumB',
        },
        buttonLabel2: {
            color: `${COLORS.WATER_BLUE}`,
            fontSize: 18,
            fontFamily: 'NanumB',
        },
        buttonLabel3: {
            color: 'red',
            fontSize: 18,
            fontFamily: 'NanumB',
        },
        empty: {
            height: '62vh',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& img': {
                width: '35vw',
                // height: '35vw',
                marginBottom: '2.5vh',
                opacity: 0.4,
            },
            '& h1': {
                color: `${COLORS.DOWN}`,
            },
        },

        productContainer: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            padding: '15px',
        },
    })
);

interface iproductList {
    productSaleAppNum: number;
    productNum: number;
    productName: string;
    productImage: string;
    companyName: string;
    companyNum: number;
    saleCompanyName: string;
    decompose_status: string;
}

export interface refHandle {
    refreshCartList: () => void;
    handleOpen: () => void;
}

type iDialog = {
    open: boolean;
    type: string;
    index: number;
};

const OperDecompositionAppList: React.FC<any> = (props) => {
    const classes = useStyles();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const history = useHistory();
    const { oper } = props;

    const count = 20;
    let max_count: number = 999;
    const loader = useRef(null);

    const [product, setProduct] = useState<iproductList[]>([]);
    const [page, setPage] = useState(-count);
    const [loading, setLoading] = useState(false);

    const [dialog, setDialog] = useState<iDialog>({
        open: false,
        type: 'approval',
        index: 0,
    });

    const handleObserver = useCallback((entries: any) => {
        const target = entries[0];
        if (target.isIntersecting) {
            setPage((prevState) => {
                if (prevState + count > max_count) {
                    return prevState;
                }
                return prevState + count;
            });
        }
    }, []);

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: '20px',
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current!);
    }, [handleObserver]);

    const handleClose = () => {
        console.log('click close');
        setDialog((prevState: any) => {
            return Object.assign({}, prevState, { open: false });
        });
    };

    const handleApprovalOpen = (index: number) => {
        if (index >= 0) {
            setDialog((prevState: any) => {
                return Object.assign({}, prevState, {
                    open: true,
                    type: 'approval',
                    index: index,
                });
            });
        }
    };

    const postProductDecomposeApprove = (product: any, money: number) => {
        let url;
        url = new URL(basic.server + v_oper.oper + v_oper.reward_price);
        // if (oper.classVersion === 4)
        //     url = new URL(basic.server + v_oper.oper + v_oper.reward_price);
        // else url = new URL(basic.server + v_oper.oper + v_oper.reward);
        axios({
            method: 'POST',
            data: {
                productSaleAppNum: product.productSaleAppNum,
                companyNum: product.companyNum,
                //money: money,
                productNum: product.productNum,
                classVersion: oper.classVersion,
            },
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                if (data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.PRODUCT_DECOMPOSE_SUCCESS, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    setProduct((prevState) => {
                        prevState.splice(dialog.index, 1);
                        return prevState.slice();
                    });
                } else if (data.code === Values.FAIL_CODE) {
                    if (data.msg)
                        enqueueSnackbar(data.msg, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    else
                        enqueueSnackbar(ToastStr.PRODUCT_DECOMPOSE_FAIL, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                } else if (data.code === Values.NETWORK_CODE) {
                    enqueueSnackbar(ToastStr.NETWORK_UNREACHABLE_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });

        handleClose();
    };

    async function getMaxProductCount(): Promise<number> {
        let url = new URL(
            basic.server + v_oper.oper + v_product.product_decompose_count
        );
        let params = { classCode: oper.classCode };
        url.search = new URLSearchParams(params).toString();

        const response = await axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        });

        const data = await response.data;
        const count: number = data.count.count;
        return count;
    }

    const getProductDecomposeList = (position: number, count: number) => {
        let url = new URL(
            basic.server + v_oper.oper + v_product.product_decompose_list
        );
        let params = {
            classCode: oper.classCode,
            position: position.toString(),
            count: count.toString(),
        };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code === Values.SUCCESS_CODE) {
                    setLoading(true);
                    if (product.length === 0 && data.products.length === 0) {
                        enqueueSnackbar(ToastStr.PRODUCT_DECOMPOSE_EMPTY_STR, {
                            variant: 'success',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else if (data.products === null) {
                        enqueueSnackbar(ToastStr.PRODUCT_DECOMPOSE_EMPTY_STR, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else {
                        if (product.length === 0) {
                            setProduct((prevState) => data.products);
                        } else {
                            setProduct((prevState) =>
                                prevState.concat(data.products)
                            );
                        }
                    }
                } else if (data.code === Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code === Values.EXCEPTION_CODE) {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };

    useEffect(() => {
        if (page >= 0) {
            getProductDecomposeList(page, count);
        }
    }, [page]);

    useEffect(() => {
        const init = async () => {
            max_count = await getMaxProductCount();
        };
        init();
    }, []);

    return (
        <Container component="main" className={classes.container}>
            <TitleBar
                history={history}
                title="분해완료요청"
                titleIcon="order"
            />

            <div style={{ width: '100%' }}>
                <List className={classes.list}>
                    {product.length != 0 ? (
                        product.map((item: any, index) => {
                            return (
                                <ListItem
                                    className={classes.productItem}
                                    alignItems="center"
                                >
                                    <ProductItem
                                        {...item}
                                        approval={() =>
                                            handleApprovalOpen(index)
                                        }
                                    />
                                </ListItem>
                            );
                        })
                    ) : (
                        <div className={classes.empty}>
                            <div>
                                <img src="/images/title/order.webp" />
                                <Typography variant="h1">
                                    제품 분해 요청이 없습니다.
                                </Typography>
                            </div>
                        </div>
                    )}
                    <div ref={loader} />
                </List>
            </div>

            <DialogConfirm
                open={dialog.open}
                handleClose={() => handleClose()}
                title={'분해 요청을 승인하겠습니까?'}
                /*
                context={
                    product.length !== 0
                    && `기업 : ${product[dialog.index].companyName}
                    상품 : ${product[dialog.index].productName}`
                }
                */
                yesConfirm={(e: any, money: number) =>
                    postProductDecomposeApprove(product[dialog.index], money)
                }
                noConfirm={() => handleClose()}
            />
        </Container>
    );
};

const ProductItem: React.FC<any> = (props) => {
    const classes = useStyles();

    const { approval } = props;

    return (
        <Grid className={classes.productContainer}>
            <Grid xs={4} className={classes.productImage}>
                <img
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        props.productImage
                    }
                />
            </Grid>
            <Grid xs={6} style={{ margin: 'auto', paddingLeft: '1vw' }}>
                <Grid container direction="column">
                    <Grid id="productName">
                        <Typography
                            display="inline"
                            variant="h3"
                            style={{
                                color: `${COLORS.BROWNISH_GREY}`,
                                fontWeight: 'bold',
                            }}
                        >
                            {`${props.productName}`}
                        </Typography>
                    </Grid>
                    <Grid id="orderStatus">
                        <Typography
                            variant="h1"
                            className={classes.productPrice}
                        >
                            {'made by ' + props.saleCompanyName}
                        </Typography>
                        <Typography
                            variant="h1"
                            className={classes.productCompanyName}
                        >
                            {props.companyName}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={2} style={{ textAlign: 'center', margin: 'auto' }}>
                <Typography variant="h1">
                    {props.productOrderDate != null &&
                        props.productOrderDate.length >= 19 &&
                        props.materialOrderDate.substring(10, 16)}
                    <Grid item>
                        <Button
                            onClick={approval}
                            className={classes.buttonLabel2}
                        >
                            승인
                        </Button>
                    </Grid>
                </Typography>
            </Grid>
        </Grid>
    );
};

export default OperDecompositionAppList;
